import { FC, memo } from 'react'

import { EventRepeatLabelProps } from './EventRepeatLabelProps'
import { getEventRepeatLabel } from './getEventRepeatLabel'

export const EventRepeatLabel: FC<EventRepeatLabelProps> = memo(({ name }) => <span>{getEventRepeatLabel(name)}</span>)
